// Miniatura de ítem (port de thumb): imagen si hay foto, si no un icono.
export function Thumb({ foto, icon = 'fa-box', className = 'mini' }: { foto?: string; icon?: string; className?: string }) {
  if (foto) return <img className={className} src={foto} alt="" />;
  return <span className={className}><i className={`fa-solid ${icon}`} /></span>;
}
